import React from "react";

const SVG = ({
  style = {},
  fill = "#000",
  className = "",
  width="22.329", 
  height="4.341",
   viewBox="0 0 22.329 4.341"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path fill={fill} id="Path_24" d="M89.847 339.746q-9.865.407-19.731 0a1.3 1.3 0 0 1-1.29-1.16q-.018-.807 0-1.614a1.3 1.3 0 0 1 1.29-1.16q9.865-.407 19.731 0a1.3 1.3 0 0 1 1.29 1.16q.018.807 0 1.614a1.3 1.3 0 0 1-1.29 1.16z" className="cls-1" data-name="Path 24" transform="translate(-68.817 -335.608)"/>
  </svg>
);

export default SVG;




// WEBPACK FOOTER //
// ./src/components/UI/Icons/Minus.js